import { createApp } from 'vue'
import App from './App.vue'
import router from './router';

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';
import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

const firebaseConfig = {
  apiKey: "AIzaSyBmayCCXtDKYk-Oowj1bvWFByQoLT9InOo",
  authDomain: "bbf-africa-d5033.firebaseapp.com",
  projectId: "bbf-africa-d5033",
  storageBucket: "bbf-africa-d5033.appspot.com",
  messagingSenderId: "921486051215",
  appId: "1:921486051215:web:fbf61284c16a3adb202dfa"
};

firebase.initializeApp(firebaseConfig);
export const database = firebase.firestore();

const app = createApp(App)
  .use(IonicVue)
  .use(router);
  
router.isReady().then(() => {
  app.mount('#app');
});